


























import Vue from "vue";

export default Vue.extend({
  name: "DatePickerField",
  props: {
    value: {
      type: [Date, Array],
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value as string | string[] | null,
      menu: false as boolean,
    };
  },
  computed: {
    fieldValue(): string {
      if (this.range) {
        return this.value && Array.isArray(this.value) && this.value.filter((val) => !!val).length >= 2
          ? this.value.join(" - ")
          : "";
      } else {
        return this.value ? this.value.toString() : "";
      }
    },
  },
  watch: {
    value(val: string | string[]): void {
      this.internalValue = val;
    },
    internalValue(val: string | string[]): void {
      if (!this.range || (Array.isArray(val) && val.filter((value) => !!value).length >= 2)) {
        this.$emit("input", val);
      }
    },
  },
});
